import { Injectable } from "@angular/core";
import { ApiAction } from "../../api-actions";
import { extractData } from "../../apiResponse/response-body-new";
import { genericApiAction } from "../../onsip-api-action-new";
import { SignupFreemiumAccountParameters } from "./signup-freemium-account";
import { Account, ApiAccount, apiAccountToAccount as clean } from "../account/account";

@Injectable({ providedIn: "root" })
export class SignupFreemiumAccountService {
  async verifiedSignupFreemiumAccount(params: SignupFreemiumAccountParameters): Promise<Account> {
    const response = await genericApiAction({
      Action: ApiAction.VerifiedSignupFreemiumAccount,
      ...params
    });
    return clean(
      extractData<ApiAccount>(response, ApiAction.VerifiedSignupFreemiumAccount, "Account")
    );
  }
}
